<template>
    <header class="checkoutHeader">
        <h1 class="checkoutTitle">Checkout</h1>
        <div class="checkoutSubtitle">Almost done...</div>
        <nav class="checkoutNav">
            <div class="checkoutNavItem"
                 :class="{'active': currentPage === 'Install and Monitoring'}"
                 @click="handleCheckoutNavClick('')"
                 ref="navInstallAndMonitoring">
                <img :src="currentPage === 'Install and Monitoring' ? '/img/credit-card-blue.png' : '/img/credit-card-gray.png'"
                     class="checkoutNavItemIcon"> Install and Monitoring
            </div>
            <div class="checkoutNavItem"
                 :class="{'active': currentPage === 'Personal Info'}"
                 @click="handleCheckoutNavClick('personal-information')"
                 ref="navPersonalInfo">
                <img :src="currentPage === 'Personal Info' ? '/img/credit-card-blue.png' : '/img/credit-card-gray.png'"
                     class="checkoutNavItemIcon"> Personal Info
            </div>
            <div class="checkoutNavItem"
                 :class="{'active': currentPage === 'Payment Info'}"
                 ref="navPaymentInfo">
                <img :src="currentPage === 'Payment Info' ? '/img/credit-card-blue.png' : '/img/credit-card-gray.png'"
                     class="checkoutNavItemIcon"> Payment Info
            </div>
        </nav>
    </header>
</template>


<script>
import { mapActions, mapState } from 'vuex'
export default {
    props: ['currentPage'],
    computed: {
        ...mapState([])
    },
    methods: {
        ...mapActions([]),

        handleCheckoutNavClick(page) {
            page = page || ''
            this.$router.push(`/assessment/checkout/${page}`)
        }
    }
}
</script>

<style lang="css"></style>
